import { Title, DataTableV2 } from "components/commons";
import locale from "localization";
import styles from "./shift-details-stock-inventory.module.scss";
import useDataTable from "hooks/useDataTable";
import { dryStockMovementColumn } from "./shift-details-stock-inventory-column";
import { dryStockMovementMapper } from "./shift-details-stock-inventory.mapper";
import { FormMode } from "enums";

const ShiftRecordDryStockMovement = ({
  shift,
  form,
  pageMode,
  inventory,
  setInventory,
  allProducts,
}) => {
  const isEdit = pageMode === FormMode.Edit;
  // const products = new Map(allProducts.map((p) => [p.productId, p]));

  const dryStockDeliveryIds = new Set(
    shift.delivery.deliveries?.filter((d) => d.productType !== "fuel")?.map((d) => d.deliveryId) ||
      [],
  );

  const computedQuantity = shift.delivery.deliveryProducts
    .filter((dp) => dryStockDeliveryIds.has(dp.deliveryId))
    .reduce((acc, dp) => {
      const sku = dp.product;
      const quantity = dp.quantityDelivered || 0;
      acc[sku] = (acc[sku] || 0) + quantity;
      return acc;
    }, {});

  const formattedList = shift.shift.inventories
    .map((inventory) => {
      // const product = products.get(inventory.productId);
      const product = allProducts.find((p) => p.productId === inventory.productId);
      const sku = product?.sku;
      let totalQuantityDelivered = sku ? computedQuantity[sku] || 0 : 0;

      const salesInventory =
        inventory.returnInventory > 0
          ? inventory.salesInventory - inventory.returnInventory
          : inventory.salesInventory;

      return {
        ...inventory,
        product: product?.name || "-",
        variant: product?.variant || "-",
        type: product?.type || "-",
        totalQuantityDelivered,
        salesInventory,
      };
    })
    .sort((a, b) => a.product.localeCompare(b.product));

  const dryStockMovementTable = useDataTable({
    value: formattedList,
    filter: { initialState: {}, mapper: (val) => val },
    table: {
      key: "inventories",
      name: "dryStockMovements",
      mapper: (val) => dryStockMovementMapper({ val, form, isEdit, inventory, setInventory }),
      columns: dryStockMovementColumn,
    },
  });

  return (
    <>
      <Title small black>
        {locale.dryStockMovement}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2
          {...dryStockMovementTable.table}
          hideNoSearchResultRender
          tableVersion="v2"
          hidePagination
        />
      </div>
    </>
  );
};

export default ShiftRecordDryStockMovement;
